// 短信营销路由
export default {
    path: 'smsmarketing',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '短信营销'},
    children: [
        //营销短信发送
        {
            path: 'sendmessage',
			component: () => import('@/components/RouterView'),
			redirect: '/smsmarketing/sendmessage/list',
            meta: { title: '营销短信发送'},
			children: [{
			    path: 'list',
			    component: () => import('@/views/smsmarketing/sendmessage/list'),
			    meta: {title: '营销短信发送'}
			},{
			    path: 'statistics/:id',
			    component: () => import('@/views/smsmarketing/sendmessage/statistics.vue'),
			    meta: {title: '短信营销数据'},
			    props:true
			}]
        },		
		//经营平台短信审核
		{
		    path: 'fbaudit',
			component: () => import('@/components/RouterView'),
			redirect: '/smsmarketing/fbaudit/list',
		    meta: { title: '经营平台短信审核'},
			children: [{
			    path: 'list',
			    component: () => import('@/views/smsmarketing/fbaudit/list'),
			    meta: {title: '经营平台短信审核'}
			},{
			    path: 'statistics/:id',
			    component: () => import('@/views/smsmarketing/fbaudit/statistics.vue'),
			    meta: {title: '短信营销数据'},
			    props:true
			}]
		},
		//计费明细
		{
		    path: 'billing/list',
		    component: () => import('@/views/smsmarketing/billing'),
		    meta: { title: '计费明细'},
			props: true
		},
		
		//权限管理
		{
		    path: 'access',
			component: () => import('@/components/RouterView'),
			redirect: '/smsmarketing/access/list',
		    meta: { title: '权限管理'},
			children: [{
			    path: 'list',
			    component: () => import('@/views/smsmarketing/access/list'),
			    meta: {title: '权限管理'}
			}]
		},		
		
    ]
};
